import React, { Fragment, useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button.js';
import styles from 'assets/jss/material-dashboard-pro-react/views/buttonsStyle.js';

//iconos
import InfoIcon from '@material-ui/icons/Info';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { Close, Edit, Save } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext.js';

import { wsUpdate } from 'services/WService';

import Write from './Write.js';
import Read from './Read.js';

const useStyles = makeStyles({
  ...styles,
  title: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
    fontSize: '20px',
  },
  marginRight: {
    float: 'right',
    marginBottom: '10px',
  },
});

export default WithApp(function Accounting(props) {
  const classes = useStyles();
  const { showNotify, businessPartner, reload } = props;

  const [isEdit, setIsEdit] = useState(false); //Editar Accounting

  const [generalData, setGeneralData] = useState({});

  const handleChange = (e) => {
    setGeneralData({ ...generalData, [e.target.name]: e.target.value });
  };

  async function save(data) {
    let newData = {};
    for (let key in data) {
      if (businessPartner[key] != data[key]) {
        newData[key] = data[key];
      }
    }

    let response = await wsUpdate('base/business-partner', businessPartner.id, newData);
    if (response.success) {
      showNotify(response.message);
      setIsEdit(false);
      reload();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    setGeneralData(businessPartner);
  }, [businessPartner]);

  return (
    <Fragment>
      <GridItem xs={12}>
        <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_ACCOUNTING_UPDATE}>
          {isEdit ? (
            <Fragment>
              <Button
                justIcon
                round
                color={props.themeContext.buttonColorDanger}
                className={classes.marginRight}
                onClick={() => setIsEdit(false)}
              >
                <Close className={classes.icons} />
              </Button>
              <Button
                justIcon
                round
                color={props.themeContext.buttonColorSuccess}
                className={classes.marginRight}
                onClick={() => save(generalData)}
              >
                <Save className={classes.icons} />
              </Button>
            </Fragment>
          ) : (
            <Button
              justIcon
              round
              color={props.themeContext.buttonColorWarning}
              className={classes.marginRight}
              onClick={() => setIsEdit(true)}
            >
              <Edit className={classes.icons} />
            </Button>
          )}
        </AllowedGuard>

        <Card>
          <CardHeader icon>
            <CardIcon color={props.themeContext.buttonColor}>
              <InfoIcon />
            </CardIcon>
            <div className={classes.title}>
              <span> Temas Contables Financieros</span>
            </div>
          </CardHeader>
          <CardBody>
            {isEdit ? (
              <Write bPartner={generalData} handleChange={handleChange} />
            ) : (
              <Read bPartner={businessPartner} showNotify={showNotify} reload={reload} />
            )}
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
